import React from 'react';

import styled from 'styled-components';

import aampeTheme from '../../../../constants/aampeTheme';
import { FormulaType } from '../../../../constants/formulaType';

import {
    FormulaDetailModel,
    FormulaSchedulingOptions,
} from 'models/formula.model';
import { TimingSlotsModel } from 'models/timing-slots.model';

import { AlternateMessagesSummary } from './summary/AlternateMessagesSummary';
import { AudienceSummary } from './summary/AudienceSummary';
import { ReachableUsersSummary } from './summary/ReachableUsersSummary';
import { SchedulingSummary } from './summary/SchedulingSummary';
import { TemplateSummary } from './summary/TemplateSummary';
import { TimeRangeSummary } from './summary/TimeRangeSummary';
import { TriggerSummary } from './summary/TriggerSummary';

export type SummaryTabProps = {
    data: FormulaDetailModel;
    timingSlots?: TimingSlotsModel[];
    schedulingType: FormulaSchedulingOptions;
    setShowTimeSlotsModal: React.Dispatch<React.SetStateAction<boolean>>;
    templateName?: string;
    isCustomTemplate?: boolean;
};
const SummaryTab: React.FC<SummaryTabProps> = ({
    data,
    timingSlots,
    schedulingType,
    setShowTimeSlotsModal,
    templateName,
    isCustomTemplate,
}) => {
    return (
        <Container>
            <ReachableUsersSummary formula={data} />
            <AlternateMessagesSummary formula={data} />
            <AudienceSummary formula={data} />
            <TriggerSummary formula={data} />
            <TimeRangeSummary
                formula={data}
                timingSlots={timingSlots}
                schedulingType={schedulingType}
                setShowTimeSlotsModal={setShowTimeSlotsModal}
            />
            <SchedulingSummary schedulingType={schedulingType} />
            {data.message_type === FormulaType.email && (
                <TemplateSummary
                    template={templateName ?? 'No Template'}
                    isCustomTemplate={isCustomTemplate}
                />
            )}
        </Container>
    );
};

export default SummaryTab;

const Container = styled.div({
    padding: aampeTheme.spacing4(5),
    gap: aampeTheme.spacing4(8),
});
